<template>
<img :src="url" class="dp">
</template>

<script>
export default {
    props: [ 'who' ],
    computed: {
        url () {
            if (this.who) {
                if (this.who.dp) {
                    return `storage/photos/${this.who.dp}`
                } else {
                    return `images/dp.png`
                }
            } else {
                return ''
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// dp.vue?bf0b6a44